var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "18px",
    height: "18px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00008 17.3334C4.39758 17.3334 0.666748 13.6025 0.666748 9.00002C0.666748 4.39752 4.39758 0.666687 9.00008 0.666687C13.6026 0.666687 17.3334 4.39752 17.3334 9.00002C17.3334 13.6025 13.6026 17.3334 9.00008 17.3334ZM9.00008 15.6667C12.682 15.6667 15.6667 12.6819 15.6667 9.00002C15.6667 5.31812 12.682 2.33335 9.00008 2.33335C5.31818 2.33335 2.33341 5.31812 2.33341 9.00002C2.33341 12.6819 5.31818 15.6667 9.00008 15.6667ZM8.16675 11.5H9.83342V13.1667H8.16675V11.5ZM9.83342 10.1292V10.6667H8.16675V9.41669C8.16675 8.95645 8.53984 8.58335 9.00008 8.58335C9.65854 8.58331 10.2041 8.07248 10.2473 7.41544C10.2905 6.7584 9.81668 6.18048 9.1639 6.09415C8.51113 6.00781 7.90331 6.44267 7.77425 7.08835L6.13925 6.76085C6.41965 5.35939 7.67404 4.3674 9.1024 4.41754C10.5308 4.46768 11.7125 5.54519 11.8939 6.96286C12.0754 8.38054 11.2031 9.72093 9.83342 10.1292Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.10aa145acdd7ddb3ad52f17bc3b7052b.svg";
export { ForwardRef as ReactComponent };